export const defaultCustomerOrderTemplate = (baseDate: Date = new Date()) => `{
  "creationDate": "${baseDate.toISOString()}",
  "buyer": {
    "commercialName": "Retail Hub Paris"
  },
  "seller": {
    "commercialName": "ACME SARL"
  },
  "contacts": [
    {
      "role": "BUYER",
      "persons": [
        {
          "givenName": "Lina",
          "familyName": "Dupont",
          "email": "lina.dupont@example.com"
        }
      ]
    }
  ],
  "customerOrderLines": [
    {
      "customerOrderLineId": "LINE-001",
      "quantity": {
        "value": 10,
        "unit": "PCE"
      },
      "originLocation": {
        "address": {
          "addressLocality": "Lyon",
          "postalCode": "69000",
          "addressCountry": {
            "countryCode": "FR",
            "countryName": "France"
          }
        }
      },
      "finalLocation": {
        "address": {
          "addressLocality": "Paris",
          "postalCode": "75015",
          "addressCountry": {
            "countryCode": "FR",
            "countryName": "France"
          }
        }
      },
      "requestedEndTimeRange": {
        "earliestDateTime": "${new Date(baseDate.getTime() + 24 * 60 * 60 * 1000).toISOString()}",
        "latestDateTime": "${new Date(baseDate.getTime() + 48 * 60 * 60 * 1000).toISOString()}"
      }
    }
  ],
  "externalReferences": [
    {
      "externalReferenceType": "BUYER_ID",
      "reference": "CO-2026-001"
    }
  ]
}`;
